<template>
  <div class="okr-detail">
    <div class="breadcrumb">
      <a-breadcrumb
        v-show="breadTitle"
        separator=">"
      >
        <a-breadcrumb-item>
          <router-link :to="breadTitleLink">
            {{ breadTitle }}
          </router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>{{ breadSubTitle }}</a-breadcrumb-item>
      </a-breadcrumb>
      <div class="okr-time">
        {{ updateTime }}
      </div>
    </div>

    <div class="okr-detail">
      <div class="okr-detail__table__header">
        <div class="okr-detail__info">
          <avatar :src="userInfo.avatar" />
          <div>
            <div>
              <span class="okr-detail__name">{{ userInfo.name }}</span>
              <span class="okr-detail__position">{{ userInfo.position }}</span>
            </div>
            <div class="okr-detail__department">
              {{ userInfo.department }}
            </div>
          </div>
        </div>
        <div class="okr-detail-btns">
          <a-button
            v-if="canEdit"
            @click="showUpload"
          >
            上传
          </a-button>
          <a-button
            v-if="canEdit"
            type="primary"
            class="okr-detail-btns-submit"
            @click="handleClickEdit"
          >
            编辑
          </a-button>
        </div>
      </div>
      <div class="okr-detail__content">
        <a-table
          :columns="columns"
          :data-source="tableData"
          row-key="dataIndex"
          bordered
          :pagination="{
            defaultPageSize: 9999,
            hideOnSinglePage: true,
          }"
        />
        <div
          v-if="showHistory"
          class="historyBox"
        >
          <div class="historyHead">
            业绩目标版本更新记录
          </div>
          <div class="historyInner">
            <div
              v-for="(v, index) in okrHistoryList"
              :key="index"
              class="historyItem"
            >
              <span class="historyTXT">{{ v.modifyDate }} 提交/上传了业绩目标</span>
              <span v-if="index===0">当前为最新版本</span>
              <a
                v-else
                @click="() => handleGotoHistory(v.id)"
              >查看此版本</a>
            </div>
          </div>
        </div>
      </div>
      <Upload
        :parame="uploadData"
        :show="isShow"
        :step="refreshStep"
        @close="closeUpload"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import { Table, Button, message, Breadcrumb } from 'ant-design-vue'

import Avatar from '@components/avatar/index.vue'
import Upload from '@components/upload/index.vue'

Vue.use(Table)
Vue.use(Button)
Vue.use(Breadcrumb)

export default {
  name: 'OKRDetail',
  components: {
    Avatar,
    Upload,
  },
  props: {},
  data() {
    const columns = [{
      title: '目标',
      dataIndex: 'objectDetail',
      customRender: (t, r) => {
        return {
          children: <div class="okr-detail__target">{t}</div>,
          attrs: {
            rowSpan: r.rowSpan,
          },
        }
      },
    }, {
      title: '权重%',
      dataIndex: 'objectWeight',
      customRender: (t, r) => {
        return {
          children: <div class="okr-detail__weight">{t}%</div>,
          attrs: {
            rowSpan: r.rowSpan,
          },
        }
      },
    }, {
      title: '关键结果',
      dataIndex: 'krDetail',
      customRender: (t) => {
        return <div class="okr-detail__kr-detail">{t}</div>
      },
    }, {
      title: '权重%',
      dataIndex: 'krWeight',
      customRender: t => <div class="okr-detail__weight">{t}%</div>,
    }, {
      title: '衡量标准',
      dataIndex: 'tenTarget',
      customRender: (t, r) => {
        const { tenTarget, sevenTarget } = r

        if (!tenTarget && !sevenTarget) {
          return null
        }

        return (
          <div>
            {
              <div class="okr-detail__kr-target">
                <span class="okr-detail__kr-target__label">7分：</span>{r.sevenTarget}
              </div>
            }
            {
              <div class="okr-detail__kr-target">
                <span class="okr-detail__kr-target__label">10分：</span>{r.tenTarget}
              </div>
            }
          </div>
        )
      },
    }]

    return {
      tableData: [],
      columns,
      userInfo: {
        name: '',
        position: '',
        department: '',
        avatar: '',
      },
      userId: '',
      year: '',
      quarter: '',
      okrId: '',
      isShow: false,
      uploadData: {},
      refreshStep: null,
      breadTitle: '',
      breadTitleLink: '',
      breadSubTitle: '',
      updateTime: '',
      okrHistoryList: [],
      showHistory: false,
      canEdit: false,

    }
  },
  computed: {
    ...mapState({
      currentTime: state => state.serverTime,
    //   currentUser: state => state.userId,
    }),
    currentUser: {
      get () {
        return this.$store.state.userId
      },
      set () {},
    },
  },
  watch: {
    currentUser() {
      this.fetchOkrDetail()
    },
  },
  created() {
    this.okrId = this.$route.params.okrId
    this.$store.dispatch('getServerTime')
    // 若userId不为空，则不用等监听，直接执行函数 （从详情点编辑当前页面跳转时会停留在空白页面的bug）
    if (this.currentUser) {
      this.fetchOkrDetail()
    }
  },
  methods: {
    /**
     * 点击编辑
     */
    handleClickEdit() {
      this.$router.push({
        name: 'EditOKR',
        params: {
          okrId: this.okrId,
          year: this.year,
          quarter: this.quarter,
        },
      })
    },
    /**
     * 获取 OKR 详情
     */
    async fetchOkrDetail() {
      const hide = message.loading('正在加载...')

      try {
        const {
          objectList,
          searchStaffInfo,
          year,
          quarter,
          onlyRead,
          userId,
          updateTime,
        } = await this.$api.okr.getDetail({
          id: this.okrId,
        })

        // const isCurrentQuarter = year === this.currentTime.year && quarter === this.currentTime.quarter
        const isCurrentUser = userId === this.currentUser
        // if (isCurrentQuarter && isCurrentUser && !onlyRead) {
        // 新增开启考评的开关，因此不局限于只能当前季度进行考评
        if (isCurrentUser && !onlyRead) {
          this.canEdit = true
        }
        this.userId = userId
        this.year = year
        this.quarter = quarter

        const departmentListLength = searchStaffInfo.departmentNameList.length
        this.$set(this, 'userInfo', {
          name: searchStaffInfo.userName,
          position: searchStaffInfo.duty,
          department: searchStaffInfo.departmentNameList[departmentListLength - 1],
          avatar: searchStaffInfo.image,
        })

        document.title = isCurrentUser ? `我的${year}年Q${quarter}季度业绩目标` : `${this.userInfo.name}的${year}年Q${quarter}季度业绩目标`
        this.breadTitle = isCurrentUser ? '我的目标' : `${this.userInfo.name}的目标`
        this.breadTitleLink = isCurrentUser ? '/' : `/user/${this.userId}`
        this.breadSubTitle = `${year}年Q${quarter}季度业绩目标`
        this.updateTime = `${searchStaffInfo.userName} ${updateTime} 提交/上传了业绩目标`

        const tableData = []
        let index = 0
        // 遍历二维数组，以 KR 为单位输出渲染列表
        objectList.forEach(objectItem => {
          const { keyResultList } = objectItem

          // 如果 O 下面没有 KR，就造一条
          if (!keyResultList || !keyResultList.length) {
            const kr = this.genNewKeyResultData

            tableData.push({
              objectDetail: objectItem.objectDetail || '-',
              objectWeight: objectItem.weight,
              krDetail: kr.keyResultDetail || '-',
              krWeight: kr.weight,
              tenTarget: kr.tenTarget || '-',
              sevenTarget: kr.sevenTarget || '-',
              rowSpan: 1,
              dataIndex: index++,
            })

            return
          }

          const krLength = keyResultList.length

          keyResultList.forEach((krItem, krIndex) => {
            tableData.push({
              objectDetail: objectItem.objectDetail || '-',
              objectWeight: objectItem.weight,
              krDetail: krItem.keyResultDetail || '-',
              krWeight: krItem.weight,
              tenTarget: krItem.tenTarget || '-',
              sevenTarget: krItem.sevenTarget || '-',
              rowSpan: !krIndex ? krLength : 0,
              dataIndex: index++,
            })
          })
        })

        this.tableData = tableData
        this.fetchOkrHistory()
        hide()
      } catch (error) {
        const msg = error.errorMessage || error.message || '网络错误'
        message.error(msg)
        // 若数据库没有该条OKR，返回列表页---待需求确认
        // if (!error.data) {
        //   setTimeout(() => { this.$router.replace({ name: 'MyOKR' }) }, 500)
        // }
        hide()
      }
    },
    /**
     * 生成新的关键结果数据
     * @return {Object} 返回新的 KR 数据
     */
    genNewKeyResultData() {
      return {
        // 关键结果详情
        keyResultDetail: '',
        // 七分目标
        sevenTarget: '',
        // 十分目标
        tenTarget: '',
        // 权重
        weight: 0,
      }
    },
    // 点击上传
    showUpload() {
      this.refreshStep = 1
      // 从缓存中拿到的id类型是string的，需要转化成number类型，符合参数需求
      this.uploadData.year = this.year
      this.uploadData.quarter = this.quarter
      if (this.okrId) {
        this.uploadData.id = parseInt(this.okrId)
      }
      this.isShow = true
    },
    // 关闭上传
    closeUpload() {
      this.isShow = false
    },
    /**
     * 获取 OKR 历史记录
     */
    async fetchOkrHistory() {
      try {
        const result = await this.$api.okr.historyList({
          userId: this.userId,
          year: this.year,
          quarter: this.quarter,

        })
        // eslint-disable-next-line
        console.log(result)
        if (result) {
          this.$set(this, 'okrHistoryList', result)
          this.showHistory = true
        }
      } catch (error) {
        const msg = error.errorMessage || error.message || '网络错误'
        // console.log(error.code)
        if (error.code !== 'illegalCall') {
          message.error(msg)
        }
      }
    },
    // 点击在新标签页打开历史版本okr
    handleGotoHistory(id) {
      if (!id) {
        return
      }
      const { href } = this.$router.resolve({
        name: 'HistoryDetail',
        params: { okrId: id },
      })
      window.open(href, '_blank')
    },

  },
}
</script>

<style lang="less">
@import '~@assets/style/variables.less';

.okr-detail {position: relative;
  &__table__header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #E8E8E8;
  }

  &__table__header,
  &__content {
    padding: 32px;
    background: @white;
    .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
      background: none;
    }
  }
  &-btns{
    font-size:0;
    button{
        padding: 0 30px;
    }
    button + button {
        margin-left:12px;
    }
    &-submit {
    background: #005EFE;

    &:hover,
    &:active,
    &:focus {
      background: @blue;
    }
  }
  }

  &__info {
    display: flex;
    color: #595959;

    > img {
      margin-right: 8px;
      width: 40px;
      height: 40px;
      border-radius: 40px;
    }
  }

  &__name,
  &__position {
    font-size: @large;
  }

  &__name {
    font-weight: 600;
  }

  &__department {
    color: #999999;
    font-size: @small;
  }

  &__target,
  &__kr-target,
  &__kr-detail {
    min-width: 200px;
    flex-grow: 1;
    white-space: pre-line; //合并空白符序列，保留换行符
  }

  &__target {
    font-weight: 600;
  }

  &__weight {
    text-align: center;
  }

  &__kr-target__label {
    font-weight: 500;
  }

  .ant-table-bordered .ant-table-thead > tr > th {
    padding: 5px 0;

    // color: @white;
    text-align: center;
    // background: #005EFE;
    &:not(:last-child) {
      border-right-color: transparent;
    }
  }
}
.breadcrumb{
margin-bottom: 40px;
padding-bottom:16px;
border-bottom: 1px solid #DDD;
}
.okr-time{
position:absolute;
right: 0;
top:38px;
height: 40px;
line-height: 40px;
font-size:13px;
color:#ccc;
}
.historyBox{margin-top:32px; border:#ddd 1px solid;}
.historyHead{height:32px; line-height: 32px; font-size: 14px; font-weight: bold; border-bottom:#ddd 1px solid; padding: 0 24px; background-color: #FAFAFA;}
.historyInner{padding: 20px 24px; font-size: 13px;
.historyItem+.historyItem{margin-top: 6px;}
}
.historyTXT{padding-right: 12px;}

</style>
